import type { SeoRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'seo'
const seoSiteRefProvider = getSiteFeatureBoundRefProvider(featureName)

const seoRefs: SeoRefs = {
	setVeloSeoTags: () => seoSiteRefProvider(['setVeloSeoTags']),
	resetVeloSeoTags: () => seoSiteRefProvider(['resetVeloSeoTags']),
}

export { seoRefs }
